import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMailArrowDownIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5,
	stroke: "currentColor",
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M15 9.95399L8.978 12.86C8.67299 13.0072 8.33868 13.0837 8 13.0837C7.66132 13.0837 7.32701 13.0072 7.022 12.86L1 9.95399V13.5C1 13.8978 1.15804 14.2794 1.43934 14.5607C1.72064 14.842 2.10218 15 2.5 15H13.5C13.8978 15 14.2794 14.842 14.5607 14.5607C14.842 14.2794 15 13.8978 15 13.5V9.95399Z",
		fill: "currentColor",
		stroke: "none"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M7.25 5V7.68945L6.03027 6.46973C5.73738 6.17683 5.26262 6.17683 4.96973 6.46973C4.67683 6.76262 4.67683 7.23738 4.96973 7.53027L7.46973 10.0303C7.76262 10.3232 8.23738 10.3232 8.53027 10.0303L11.0303 7.53027C11.3232 7.23738 11.3232 6.76262 11.0303 6.46973C10.7374 6.17683 10.2626 6.17683 9.96973 6.46973L8.75 7.68945V5H13.5C13.8978 5 14.2792 5.15815 14.5605 5.43945C14.8419 5.72076 15 6.10218 15 6.5V8.29297C14.9741 8.30224 14.9486 8.31315 14.9238 8.3252L8.32617 11.5098C8.12017 11.6098 7.87983 11.6098 7.67383 11.5098L1.07617 8.3252C1.05117 8.3132 1.026 8.30197 1 8.29297V6.5C1 6.10218 1.15815 5.72076 1.43945 5.43945C1.72076 5.15815 2.10218 5 2.5 5H7.25ZM8 1C8.41421 1 8.75 1.33579 8.75 1.75V5H7.25V1.75C7.25 1.33579 7.58579 1 8 1Z",
		fill: "currentColor",
		stroke: "none"
	})]
});
export default SvgMailArrowDownIcon;
